import { DEFAULT_CLIENT_NAME } from './constants';
// TODO Temporary solution for handling Cookie header
export class AppState {
}
AppState.clientName = DEFAULT_CLIENT_NAME;
AppState.isExternalDomain = false;
AppState.planogramName = '';
